export default __webpack_public_path__ + "static/media/freshdesk-icon.6a59a35d.svg";